import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { STORE_URL } from "../shared/src";

@Injectable({
    providedIn: 'root',
})
export class StoreAreaSizeService {

    private readonly STORE_AREA_SIZE_URL = `${STORE_URL}/storeAreaSize`;

    constructor(private http: HttpClient) { }

    getAll(): Observable<any> {
        return this.http.get<any>(`${this.STORE_AREA_SIZE_URL}/getAll`);
    }
}